import React, { useState } from "react";
import type { AxiosResponse } from "axios";
import {
  Button,
  Col,
  Divider,
  message,
  Modal,
  Row,
  Spin,
  Tooltip,
  Upload,
  UploadProps,
} from "antd";
import uniqueId from "lodash/uniqueId";
import { ReactComponent as FileIcon } from "../../../../../img/shape.svg";
import { ReactComponent as UploadFileIcon } from "../../../../../img/add-file.svg";
import { ReactComponent as DeleteFileIcon } from "../../../../../img/delete-file-icon.svg";
import { FileMetaData } from "../../../model/types/FileMetaData";
import "./CreateAdjustmentFiles.less";

const acceptedFileTypes =
  ".jpg, .jpeg, .png, .pdf, .rtf, .doc, .docx, msword, vnd.openxmlformats-officedocument.wordprocessingml.document, .xls, .xlsx, vnd.openxmlformats-officedocument.spreadsheetml.sheet, vnd.ms-excel";

const getFileName = (file?: FileMetaData) => file?.contentName?.replace("/files/", "");

interface IProps {
  isLoading: boolean;
  startLoading: () => void;
  stopLoading: () => void;
  deleteFile: (fileId: number) => Promise<AxiosResponse<any>> | undefined;
  uploadedFiles: FileMetaData[] | undefined;
  setUploadedFiles: React.Dispatch<React.SetStateAction<FileMetaData[] | undefined>>;
  uploadFiles: UploadProps["onChange"];
}

export const CreateAdjustmentFiles = (props: IProps) => {
  const {
    isLoading,
    startLoading,
    stopLoading,
    deleteFile,
    uploadedFiles,
    setUploadedFiles,
    uploadFiles,
  } = props;
  const [deletedFile, setDeletedFile] = useState<{ name?: string; id: number }>();
  const closeConfirmDeleteFileModal = () => {
    setDeletedFile(undefined);
  };

  const confirmDeleteFile = async (fileId: number) => {
    startLoading();
    const deleteResult = await deleteFile(fileId);
    if (deleteResult) {
      setUploadedFiles((prev) => (prev || []).filter(({ id }) => id !== fileId));
      message.success("Файл удален");
    }
    stopLoading();
    closeConfirmDeleteFileModal();
  };

  return (
    <>
      <div className="create-adjustment-files">
        <Spin spinning={isLoading}>
          <div style={{ backgroundColor: "white", width: "100%" }}>
            <Row gutter={20}>
              {uploadedFiles?.map((file) => (
                <Col
                  key={uniqueId()}
                  style={{ paddingLeft: 0, paddingRight: 0, paddingTop: 6, marginRight: "-15px" }}
                >
                  <Tooltip title="Удалить файл">
                    <DeleteFileIcon
                      style={{
                        cursor: "pointer",
                        position: "relative",
                        top: "-37px",
                        left: "36px",
                        zIndex: 1,
                      }}
                      onClick={() => {
                        setDeletedFile({ name: getFileName(file), id: file?.id });
                      }}
                    />
                  </Tooltip>
                  <Tooltip title={getFileName(file)}>
                    <FileIcon />
                  </Tooltip>
                </Col>
              ))}
              <Upload
                accept={acceptedFileTypes}
                multiple
                showUploadList={false}
                customRequest={() => {}}
                onChange={uploadFiles}
              >
                <UploadFileIcon
                  style={{
                    cursor: "pointer",
                    marginLeft: uploadedFiles && uploadedFiles.length > 0 ? "5px" : "4px",
                  }}
                />
              </Upload>
            </Row>
          </div>
        </Spin>
      </div>
      <Modal
        visible={Boolean(deletedFile?.id)}
        width="690px"
        onCancel={closeConfirmDeleteFileModal}
        footer={
          <>
            <Button onClick={closeConfirmDeleteFileModal}>Отмена</Button>
            <Button type="primary" onClick={() => confirmDeleteFile(deletedFile!.id)}>
              Удалить
            </Button>
          </>
        }
      >
        <h2>Удаление файла</h2>
        <Divider className="thin-divider" style={{ marginTop: 10 }} />
        <div>Вы действительно хотите удалить выбранный файл: {deletedFile?.name}?</div>
      </Modal>
    </>
  );
};
